import { render, staticRenderFns } from "./msgCode.vue?vue&type=template&id=d6560d00&scoped=true&"
import script from "./msgCode.vue?vue&type=script&lang=js&"
export * from "./msgCode.vue?vue&type=script&lang=js&"
import style0 from "./msgCode.vue?vue&type=style&index=0&id=d6560d00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6560d00",
  null
  
)

export default component.exports